import { render, staticRenderFns } from "./StartFinishConfig.vue?vue&type=template&id=a1ad2096&"
import script from "./StartFinishConfig.vue?vue&type=script&lang=js&"
export * from "./StartFinishConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports